import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6647aef0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647aef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6647aef0')) {
      api.createRecord('6647aef0', component.options)
    } else {
      api.reload('6647aef0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6647aef0&scoped=true&", function () {
      api.rerender('6647aef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/OssExcleCon/index.vue"
export default component.exports